import { render, staticRenderFns } from "./exchangeModal.vue?vue&type=template&id=d7a95f74&scoped=true"
import script from "./exchangeModal.vue?vue&type=script&lang=js"
export * from "./exchangeModal.vue?vue&type=script&lang=js"
import style0 from "./exchangeModal.vue?vue&type=style&index=0&id=d7a95f74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a95f74",
  null
  
)

export default component.exports